export const RolesSetInitialState = () => {
    let roles: any = []

    const rolesObject = localStorage.getItem('roles');

    if(rolesObject) {
        roles = JSON.parse(rolesObject);
    }

    return roles;
}